import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useDispatch,useSelector } from "react-redux";
import axios from "axios";
import Navbar from '../component/NavbarDashboard';
import Footer from "../component/Footer";
import { DashboardNavProvider } from "component/DashboardNav/DashboardNavContext";
import { set_plan, set_user, set_account_context } from "redux/reducer/user";
import { getActiveAccountId, setActiveAccountId } from "utils/accountContext";
import NoCoin from "component/Modal/NoCoin";
import OnboardingWalkthrough from "component/OnboardingWalkthrough";
import PayNow from "pages/private/pay-now";
import { set_category } from "redux/reducer/crypto";
import { getAllCategory } from "api/crypto";
import { requestPermission } from "utils/PushNotification";
import { onMessageListener } from "firebaseConfig";
import { hasActivePlan } from "utils/planAccess";

export const DashboardLayout = () => {
    const { plan, loaded, isAdmin } = useSelector(state => state.user);
    const dispatch=useDispatch();
    const navigate = useNavigate();
    const location=useLocation();
    const {crypto,isLive,cryptoLoaded} = useSelector(state=>state.crypto)

    useEffect(()=>{
        window.scrollTo(0,0)
    },[location])
   // code for persistence login
    useEffect(() => {
        axios.get('/api/v1/user/profile')
            .then(res => {
                dispatch(set_user(res.data.user))
                dispatch(set_plan(res.data.plan))
                const switchableAccounts = res.data.switchableAccounts || [];
                const activeAccountId = getActiveAccountId() || res.data.activeAccountId || res.data.user?._id;
                if (switchableAccounts.length > 1 && !getActiveAccountId()) {
                    setActiveAccountId(res.data.user?._id);
                }
                dispatch(set_account_context({
                    switchableAccounts,
                    activeAccountId: activeAccountId || res.data.user?._id,
                    isAdmin: Boolean(res.data.isAdmin),
                }))
                if (!window.location.pathname.includes('/dashboard/')) {
                    navigate('/dashboard/main');
                }
            })
            .catch((err) => {
                console.log(err)
                if (err.response?.status === 401) {
                    navigate('/login');
                }
                dispatch(set_user(null))
            })
       getAllCategory()
        .then(res=>{
            dispatch(set_category(res.data.category))
        }).catch(err=>console.log(err))

        setTimeout(() => {
            if(window.innerWidth<800){
                //request permission for push notification for mobile only
                requestPermission();
                onMessageListener()
                .then((payload) => {
                  alert(payload?.notification?.title +"  " +payload?.notification?.body);     
                })
                .catch((err) => console.log('failed: ', err));
            }
        }, 1000*10);
       
    }, [])

    const isAdminDashboard = location.pathname.startsWith('/dashboard/admin');
    const canAccessDashboard = hasActivePlan(plan) || (isAdmin && isAdminDashboard);
    //     if (!user && loaded) {
    //         navigate('/login')
    //     }
    // }, [user, loaded, navigate])

    return (
        <DashboardNavProvider>
            <Navbar />
            {!isLive &&
            <Box sx={{background:"rgb(187, 68, 68)",width:"100%",py:1.7,mt:1,position:'fixed',top:'55px',zIndex:1000}}>
                <Typography sx={{color:"#fff",textAlign:'center',fontWeight:'bold',fontSize:18}}>LIVE PRICING TEMPORARILY NOT AVAILABLE</Typography>
            </Box>}
            <Box sx={{  bgcolor: 'primary.main', minHeight: 'calc(100vh - 55px)',overflowY:'scroll' }}>
                {!loaded ? <Box sx={{ minHeight: "90vh" }}>
                    <CircularProgress sx={{ color: '#fff' }} />
                </Box> :
                  
                   <>
                    {canAccessDashboard ? <Outlet /> : <PayNow/>}
                    {(crypto && !crypto.length && cryptoLoaded) &&  <NoCoin/>}
                    {canAccessDashboard && loaded && !isAdminDashboard && <OnboardingWalkthrough />}
                    </>
                }
            
            </Box>
        </DashboardNavProvider>
    )
}

export default DashboardLayout;